// İşten çıkış bilgisi gösterim sözleşmesi (müşteri geri bildirimi 2026-08).
// Kaynak: ayrılış süreci tamamlanınca damgalanan Employee.TerminationDate +
// ExitReasonCode (OD'siz tenant'ta İK form üzerinden elle girer). Elle deaktive
// edilmiş çalışanlarda veri yoktur — pasif çalışanda alanlar yine gösterilir,
// değer "-" kalır (dürüst boşluk, gizlenmiş bilgi değil).

export function shouldShowExitInfo(employee) {
  if (!employee) return false;
  if (employee.isActive === false) return true;
  return Boolean(employee.terminationDate || employee.exitReasonCode);
}

// Kod → yerelleştirilmiş etiket; sözlükte olmayan kod ham gösterilir (veri
// gizlenmez), boş kod "-" döner.
export function exitReasonLabel(t, code) {
  if (!code) return '-';
  return t(`employee.exitReasons.${code}`, { defaultValue: code });
}
